import React from "react";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
// import useGetSiteImage from "../../hooks/useGetSiteImage"

const CustomImage = styled("img")({
  width: "auto",
  paddingTop: "7px",
});

// const logoImageName = "MainLogo.png";

export default function Logo({ logoHeight }) {
  // const { imageURL, error } = useGetSiteImage(logoImageName);

  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <CustomImage
        src={process.env.REACT_APP_CLIENT_URL + "/images/MainLogo.png"}
        // src={!error ? imageURL : ""}
        alt="Home"
        style={{ height: logoHeight }}
      />
    </Link>
  );
}